import {Component, Input, Output, EventEmitter, OnChanges, OnInit, AfterViewInit, ViewChildren, QueryList, DoCheck} from '@angular/core';
import { groupBy, orderBy } from 'lodash';

import { BaseSegmentComponent } from '../base/_base-segment.component';
import { isImageFileType } from 'shared/digital-assets/digital-asset-helpers';
import {AssetFieldItem} from 'shared/digital-assets/digital-assets-segment-data';
import {PrettifySizePipe} from 'shared/pipes/prettify-size.pipe';
import {DigitalAssetDetailsService} from '../../digital-asset-details.service';
import {PermissionsService} from 'shared/permissions/permissions.service';
import * as _ from 'lodash';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidatorFn} from '@angular/forms';
import {SegmentFieldItem} from 'utils/segment-field-item.interface';
import * as utils from 'utils/utils';
import {DigitalAsset} from '../../../digital-assets-panel/digital-assets-form/digital-asset.model';
import {digitalAssetsSegmentData} from '../../digital-assets-segment-data';
import * as dateUtils from 'utils/date';
import {Option} from 'shared/form/select/option.interface';
import {DetailsControlType} from 'shared/details-page/details-control/details-control-type';
import {digitalAssetErrors} from 'shared/digital-assets/digital-asset-errors';
import {finalize} from 'rxjs/operators';
import {DigitalAssetsService} from 'shared/digital-assets/digital-assets.service';
import {DetailsControlComponent} from 'shared/details-page/details-control/details-control.component';


@Component({
  moduleId: module.id,
  selector: 'asset-details-segment',
  templateUrl: 'asset-details.component.html',
  styleUrls: ['asset-details.component.scss'],
})
export class AssetDetailsComponent extends BaseSegmentComponent implements OnChanges, OnInit {

  showMoreData: any = [];
  showMore: boolean = false;
  isImageFileType: boolean;

  sourceData: any;
  segmentData = digitalAssetsSegmentData;

  selectedLanguageItem: any;
  languageItems: Array<any> = [];
  loopingFields: Array<string> = ['asc', 'des'];

  @ViewChildren('loopingControl')
  loopingControls: QueryList<DetailsControlComponent>;
  loopingData: any[] = [];

  @Input() form: UntypedFormGroup;
  @Input() declare assetDetail: any;

  @Output() openPanel  = new EventEmitter();
  @Output() saveClick  = new EventEmitter<any>();

  constructor(
    protected digitalAssetDetailsService: DigitalAssetDetailsService,
    protected permissionsService: PermissionsService,
    private prettifySizePipe: PrettifySizePipe,
    private fb: UntypedFormBuilder,
    private digitalAssetsService: DigitalAssetsService,
  ) {
    super(digitalAssetDetailsService, permissionsService);

  }

  ngOnInit() {
    this.createForm();
    this.sourceData = this.data;
  }

  ngOnChanges() {
    this.data = this.orderBy(this.data);
    this.isImageFileType = isImageFileType(this.assetDetail);
    this.setFormData();
  }

  get selectedLanguageLower(): string {
    return _.toLower(this.selectedLanguage);
  }

  get selectedLanguage(): string {
    return _.get(this.selectedLanguageItem, 'code', 'EN');
  }

  get loopingItems() {
    return this.segmentData.filter(i => i.type === 'list');
  }

  // handlers:
  onEditButtonClick() {
    this.editMode = !this.editMode;
  }

  onCancelButtonClick() {
    this.data = this.sourceData;
    this.setFormData();
    this.editMode = !this.editMode;
  }

  onSaveButtonClick() {
    this.editMode = !this.editMode;

    const fileNameControl = this.form.get('filename');
    // if (fileNameControl.invalid && _.has(fileNameControl.errors, 'unique')) {
    //   this.errorModalTitle = digitalAssetErrors.filenameUniq;
    //   if (this.errorModal) {
    //     this.errorModal.show();
    //   }
    //   return;
    // }
    this.saveClick.emit(this.form?.value);
  }

  onDateChange(selectedDate: string, item: any, formGroup: UntypedFormGroup, index: number) {
    if (item.field_map === 'expirationDate') {
      dateUtils.handleDateAheadChange(
        formGroup.get('effectiveDate'),
        'effectiveDate',
        selectedDate,
        this.segmentData,
        index
      );
    }
  }

  onAssetStatusChange(status: string, item: AssetFieldItem, index: number) {
    // this.scorecardConnectorService.controlStatusChanged.emit({status, item, index});
  }

  onAssetPopulatedChange(populated: number, item: AssetFieldItem, index: number) {
    // this.scorecardConnectorService.controlPopulatedChanged.emit({populated, item, index});
  }

  onControlFocus(item: any, index?: number) {
    // this.scorecardConnectorService.controlFocused.emit({item, index});
  }

  onSelectChange(option: Option, item: any) {

  }

  onAddAnotherClick(item, language: string) {
    // const validators: any = this.getFieldValidators(item);
    const validators: any = null;
    const formArray: any = this.getLoopingFormArray(item.field_map, language);
    formArray.push(new UntypedFormControl('',  validators));
    // this.scorecardConnectorService.controlAdded.emit({
    //   item, index: formArray.length - 1, language: this.selectedLsanguage,
    // });
    // _.defer(() => {
    //   this.focusOnLastLoopingControl(item.field_map);
    //   this.markAsDirty();
    // });
  }

  onDeleteControlClick(control: UntypedFormControl, item, language: string) {
    const formArray: any = this.getLoopingFormArray(item.field_map, language);
    if (!formArray) { return console.warn('formArray not found!'); }
    const index = formArray.controls.indexOf(control);
    formArray.removeAt(index);
    // this.scorecardConnectorService.controlRemoved.emit({
    //   item, index, language: this.selectedLanguage,
    // });
    // this.markAsDirty();
  }

  onLanguageChange(event: any) {
    // this.selectedLanguageItem = event;
    // this.ref.markForCheck();
  }

  // private:
  private showItem(item: any): boolean {
    switch (item.item_name) {
      case 'file_type':
      case 'filesize':
      case 'color_mode':
      case 'resolution':
        return false;
      default:
        return this.isImageFileType ? true : !item.imageOnly;
    }
  }

  private getAssetValue(asset: any, item: AssetFieldItem): string|number {
    const value = this.getFieldValue(asset, item);
    if (item.item_name === 'file_size') {
      return this.prettifySizePipe.transform(value);
    } else if (item.item_name === 'width' || item.item_name === 'height') {
      return (value && asset.uom) ? `${value} ${asset.uom}` : '-';
    } else {
      return value;
    }
  }

  private createForm(): void {
    const formControls = utils.populateModel(DigitalAsset, this.segmentData, this.data, this);
    this.form = this.fb.group(formControls);
    this.form.setControl('asc', new UntypedFormArray([new UntypedFormControl('')]));
    this.form.setControl('des', new UntypedFormArray([new UntypedFormControl('')]));
  }

  setFormData() {
    if (!this.assetDetail?._id) {
      return;
    }
    this.data.map((item) => {
      if (item.type === 'list') {
        this.buildLoopingFormArray(item, 'EN', null);
      } else {
        this.form.setControl(item.field_map, this.fb.control(this.assetDetail[item.item_name]));
      }
    });
    this.form.markAsDirty();
  }

  protected getLookup(name: string, segmentData: Array<SegmentFieldItem>): any {
    return utils.getLookup(name, segmentData);
  }
  public getItemTitle (item: SegmentFieldItem): string {
    return item?.title;
  }

  getControlType(item: any): string {
    if (item.lookup || _.get(item, 'api_lookup.type') === 'list') {
      return DetailsControlType.Select;
    } else if (item.type && item.type === DetailsControlType.Date) {
      return DetailsControlType.Date;
    } else if (item.type === 'textarea') {
      return DetailsControlType.Textarea;
    } else {
      return DetailsControlType.Input;
    }
  }

  isLoopingField(item: any): boolean {
    return (item.field_map === 'descriptions');
  }

  getLoopingFormArray(fieldMap, language: string): UntypedFormArray {
    if (!this.form || !this.assetDetail?._id) {
      return this.fb.array([new UntypedFormControl('')]) as UntypedFormArray;
    }
    const loopingFormArray = this.form?.controls[fieldMap];
    return loopingFormArray as UntypedFormArray;
  }

  getDescriptions() {
    if (!this.form || !this.assetDetail?._id) {
      return {};
    }
    return this.form?.controls['descriptions'].value || {};
  }

  onChangeDescriptions($event) {
    this.form.controls['descriptions'].setValue($event);
  }

  isLoopingFieldMasked(item: SegmentFieldItem, i: number): boolean {
    return false;
    // return this.hasScores ? (!this.hasItemInScores(item) && !this.hasLoopingItemInScores(item, i)) : false;
  }

  getItemValidation(item: SegmentFieldItem): any {
    const scoreRule = this.getItemScoreRule(item);
    return this.getItemValidationByRuleName(item, _.get(scoreRule, 'validation_rule'));
  }

  protected getItemValidationByRuleName(item: SegmentFieldItem, ruleName: string): any {
    const validationRules = _.get(item, `validation.${ruleName}`, {});
    // pies67 === pies65
    if (_.isEmpty(validationRules) && ruleName === 'pies67') {
      return _.get(item, `validation.pies65`, {});
    }
    return validationRules;
  }

  onLoopingControlStatusChange(status: any, item: SegmentFieldItem, index: number) {
    // this.scorecardConnectorService.controlStatusChanged.emit({
    //   status, item, index, language: this.selectedLanguage
    // });
  }
  onLoopingControlFocus(item: SegmentFieldItem, index: number) {
    // this.scorecardConnectorService.controlFocused.emit({
    //   item, index, language: this.selectedLanguage
    // });
  }
  onTextPopulatedChange(populated: number, item: SegmentFieldItem, index: number) {
    // this.scorecardConnectorService.controlPopulatedChanged.emit({
    //   populated, item, index, language: this.selectedLanguage
    // });
  }
  protected getFieldValidators(item: SegmentFieldItem)/*: Array<ValidatorFn>*/ {
    // const score = this.getScorecardField(item.item_name);
    // const validationRule = _.get(score, 'validation_rule'); // pies65, pies64, etc
    // const required = _.get(score, 'required', false);
    // const validation = this.getItemValidationByRuleName(item, validationRule);
    // validation.conditionals = null;
    // validation.required = required;
    //
    // // find all conditionals where item is in 'required' -
    // // we need to find what fields it depends on
    // const conditionals = this.getRequiredConditionalsForField(item.item_name); // from scorecard item, 'custom_validation_rules'
    //
    // if (conditionals) {
    //   validation.required = null;
    //   validation.conditionals = createScoreFieldRequiredValidation(conditionals);
    // }
    //
    // return this.initValidators(validation, this);
  }

  protected getItemScoreRule(item: any): any {
    // return _.get(this.getItemScore(item), 'rule');
  }

  private buildLoopingFormArray(item: SegmentFieldItem, language: string = 'EN', validators: Array<any>) {
    const oData: any = _.get(this.assetDetail, item.item_name);
    this.form.setControl(item.field_map, new UntypedFormArray([]));
    const formArray = this.form.get(item.field_map) as UntypedFormArray;
    if (oData) {
      _.each(oData, (desc) => {
        formArray.push(new UntypedFormControl(desc));
      });
    } else {
      // always add one empty element to the controls array
      formArray.push(new UntypedFormControl(''));
    }
  }
}
